import { pocOtherBlueprint } from './pocOtherBlueprint';
import { standardBlueprint } from './standardBlueprint';

export { pocOtherBlueprint, standardBlueprint };
export const blueprintVersions = [
  standardBlueprint,
  pocOtherBlueprint,
] as const;

export const standardBlueprintVersion = standardBlueprint.version;
export const POC_OTHER_BLUEPRINT_VERSION = pocOtherBlueprint.version;
